<template>
  <v-row no-gutters class="pt-5 pr-2">
    <v-col v-if="computedIsFetched">
      <card-title-row :straight-title="additionalModuleName">
        <template #buttons>
          <base-rounded-button
            v-if="permissionsEasements.main_value > 1"
            icon="mdi-plus"
            size="x-small"
            color="success"
            :tooltip="$i18n.t('button.addEasement')"
            @click="toggleTransmissionAdding"
          />
        </template>
      </card-title-row>
      <card-title-row
        is-subtitle
        translation-path="sidebar.visualisationOnMap"
        :amount="1"
        :is-plural="true"
        class="pt-2"
      />
      <sidebar-row class="pt-2">
        <sidebar-select-row
          translation-path="sidebar.visualizationType"
          font-size="14px"
          @input="handleStyleChange"
          :value="currentStyle"
          :select-props="styleSelectProps"
        ></sidebar-select-row>
      </sidebar-row>
      <module-legend ref="moduleLegend" module-name="transmission_easement" />
    </v-col>
    <v-col v-else>
      <main-loader></main-loader>
    </v-col>
  </v-row>
</template>

<script>
import MainLoader from '@/components/MainLoader';
import SidebarSelectRow from '@/components/SidebarSelectRow';
import SidebarRow from '@/components/SidebarRow';
import CardTitleRow from '@/components/CardTitleRow';
import { call, get } from 'vuex-pathify';
import ModuleLegend from '@/components/ModuleLegend';

export default {
  name: 'TransmissionEasements',
  components: { ModuleLegend, MainLoader, SidebarSelectRow, SidebarRow, CardTitleRow },
  computed: {
    additionalModuleName: get('admin/additionalModules@TRANSMISSION_EASEMENT.verbose_name'),
    permissions: get('users/toolsPermissions'),
    dataSourceName: get('admin/modulesMapping@transmission_easement.datasource_name'),
    styles: get('styles/styles@:dataSourceName'),
    currentStyle: get('styles/currentStyle@:dataSourceName'),
    defaultStyle: get('styles/defaultStyle@:dataSourceName'),
    loaded: get('modules/loaded@:dataSourceName'),

    computedIsFetched() {
      return this.isFetched && this.loaded;
    },
    permissionsEasements() {
      return this.permissions['TRANSMISSION_EASEMENT'];
    },
    computedSelectStyles() {
      return [this.defaultStyle, ...this.$_sortObjectsByAttribute([...this.styles], 'name')];
    },
    styleSelectProps() {
      return {
        items: this.computedSelectStyles,
        itemText: 'name',
        itemValue: 'id',
        returnObject: true,
      };
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getEasements: call('layers/getEasements'),
    setCurrentStyle: call('styles/setCurrentStyle'),
    getStyles: call('styles/getStyles'),

    async handleStyleChange(style) {
      await this.setCurrentStyle({ dataSource: this.dataSourceName, style: style });
      this.$root.$emit('easementsStyleChanged', style);
      await this.$refs.moduleLegend.getModuleStyle();
    },
    toggleTransmissionAdding() {
      this.$router.push({
        name: 'transmission_easement',
        params: { fid: 'new' },
      });
    },
    async init() {
      await Promise.all([this.getEasements(), this.getStyles(this.dataSourceName)]);
      this.isFetched = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.border-bottom {
  @include border(bottom);
}
</style>
